module.exports = __webpack_public_path__ + "static/media/simulator.7c5deaad.jpg";